import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.circuitprinting.com";
const DEFAULTS = {
  title: "Circuit Printing Solutions | Quality Printing in Canada",
  description: "Professional printing solutions for Canadian businesses, including business cards, flyers, brochures, banners, labels, and custom print orders.",
};

const PAGE_META = {
  "/": { title: "Professional Printing Solutions in Canada | Circuit Printing Solutions", description: "Order high-quality business cards, flyers, brochures, banners, labels, and custom printing for your Canadian business." },
  "/products": { title: "Print Products | Business Cards, Flyers, Brochures & More", description: "Explore professional print products for Canadian businesses, with quality materials, flexible quantities, and reliable delivery." },
  "/about": { title: "About Circuit Printing Solutions | Canadian Printing Experts", description: "Learn about Circuit Printing Solutions and our commitment to reliable, high-quality printing for Canadian businesses." },
  "/contact": { title: "Contact Circuit Printing Solutions | Request a Print Quote", description: "Contact our Canadian printing team for a quote, artwork help, order support, or advice on your next print project." },
  "/blogs": { title: "Printing Tips & Business Design Ideas | Circuit Printing Blog", description: "Read practical printing, artwork, branding, and business design advice from Circuit Printing Solutions." },
  "/purchasing-guide": { title: "Printing Purchasing Guide | Circuit Printing Solutions", description: "A practical guide to choosing print products, quantities, finishes, artwork, and delivery options." },
  "/faq": { title: "Printing FAQs | Circuit Printing Solutions", description: "Find answers about print products, artwork, turnaround times, delivery, payment, and custom orders." },
  "/artwork-guidelines": { title: "Artwork Guidelines | Print-Ready File Requirements", description: "Prepare print-ready artwork with the correct PDF format, bleed, resolution, colour mode, and file settings." },
  "/submit-order": { title: "Submit a Custom Print Order | Circuit Printing Solutions", description: "Submit your custom printing requirements, artwork, quantities, delivery details, and target date for a tailored review." },
};

function upsertMeta(attribute, key, content) {
  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) { tag = document.createElement("meta"); tag.setAttribute(attribute, key); document.head.appendChild(tag); }
  tag.setAttribute("content", content);
}

export default function SEO() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = PAGE_META[pathname] || (pathname.startsWith("/products/")
      ? { title: "Print Product Details | Circuit Printing Solutions", description: "View product options, pricing, finishes, and turnaround details for professional printing in Canada." }
      : pathname.startsWith("/blogs/")
        ? { title: "Printing Advice & Business Design | Circuit Printing Solutions", description: "Helpful printing and design information from Circuit Printing Solutions." }
        : DEFAULTS);
    const canonicalPath = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    const canonical = `${SITE_URL}${canonicalPath}`;
    document.title = meta.title;
    upsertMeta("name", "description", meta.description);
    upsertMeta("property", "og:title", meta.title);
    upsertMeta("property", "og:description", meta.description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("name", "twitter:title", meta.title);
    upsertMeta("name", "twitter:description", meta.description);
    const privateRoute = pathname.startsWith("/admin") || ["/login", "/account", "/checkout", "/cart"].includes(pathname);
    upsertMeta("name", "robots", privateRoute ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    let link = document.head.querySelector("link[rel=canonical]");
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonical;
  }, [pathname]);
  return null;
}
